<div class="Main-Container">
    <div class="spider-container">        
        <div class="spider-txt-img"></div>
    </div>
    <div class="main-section" *ngIf="isSnapshot">
      <div class="tab-section" [ngClass]="{'search-open': isOpen}">
          <div class="tab-track" [@tabSlide]="pageIndex">
            <div
              class="tab-box"
              *ngFor="let item of visibleTabs; let i = index"
              (click)="studyNameclick(item,i)"
            >
              <div class="tab" [ngClass]="{ 'active-tab': (pageIndex * visibleCount + i)   === activeIndex }">
                <!-- <span
                  [title]="item.length > 25 ? (item | titlecase) : ''"
                  [ngClass]="{ 'text-ellipsis': item.length > 25 }"
                >
                  {{ item.length > 25 ? (item | slice:0:25) + '...' : item }}
                </span> -->
                <span class="text-ellipsis" [title]="item">{{ item }}</span>

              </div>
            </div>
          </div>

    <div class="tab-controls-right">
      <ng-container *ngIf="totalSnapshots > visibleCount">
        <button class="tile-arrow left"
            [disabled]="!canShowPrev"
            [ngClass]="{'disabled-arrow': !canShowPrev}"
            (click)="canShowPrev && showPrev()"
            aria-label="Previous"
            [attr.aria-disabled]="!canShowPrev">
          <img src="assets/images/arrowslefticon.svg" alt="Previous" />
        </button>
        <button class="tile-arrow right"
            [disabled]="!canShowNext"
            [ngClass]="{'disabled-arrow': !canShowNext}"
            (click)="canShowNext && showNext()"
            aria-label="Next"
            [attr.aria-disabled]="!canShowNext">
          <img src="assets/images/arrowsrighticon.svg" alt="Next" />
        </button>
      </ng-container>
      
        </div>
        <div class="tile-search-container">
            <!-- Search Icon -->
            <button (click)="toggleSearch()" class="search-icon">
              <img src="assets/images/search.svg" alt="Search" />
            </button>

              <!-- Search Bar -->
            <div class="search-bar" [ngClass]="{ 'open': isOpen }">
                <input #searchInput type="text" placeholder="Search snapshot name or type" [(ngModel)]="searchText"/>
                <button (click)="toggleSearch()" class="close-btn">
                  <img src="assets/images/close_btn.svg" alt="Close" class="close-icon" />
                </button>
            </div>

            <div *ngIf="isOpen && searchText" class="search-dropdown">
              <div *ngFor="let snapshot of filteredSnapshots" 
                  class="search-dropdown-item"
                  (click)="selectSnapshot(snapshot)">              
                <span class="search-name" [innerHTML]="highlightText(snapshot.name)"></span> |
                <span class="search-type" [innerHTML]="highlightText(snapshot.type)"></span> |
                <ng-container *ngIf="!snapshot.subSection">
                  <span class="search-section" [innerHTML]="highlightText(snapshot.section)"></span>
                </ng-container>

                <ng-container *ngIf="snapshot.subSection">
                  <span class="search-section" [innerHTML]="combineHighlight(snapshot.section, snapshot.subSection)"></span>
                </ng-container>       
              </div>

              <div *ngIf="filteredSnapshots.length === 0" class="search-no-results">
                No results found
              </div>
            </div>
          </div>
      </div>
      <div class="tiles-holder">
        <ng-container *ngIf="isCustomSnapshotWidgetLibrary; else noSnapshot">
          
          <!-- Loop through ALL items -->
          <div [ngClass]="'Categ-' + (i+1)" *ngFor="let item of AcrossDropdown; let i = index">
            
            <!-- Dynamic class: Categ-1, Categ-2, Categ-3 ... -->
            
              <div class="category-title">
                <span class="category-name">{{ item.snapshotType_name }}</span>
              </div>

              <div class="tile-container">
                <ng-container *ngFor="let section of item.section">
                  <!-- Case: no subsections -->
                  <div class="tiles tile-normal"
                      [ngClass]="{'tile-disabled': section.section_name === 'Disabled Example'}"
                      *ngIf="!section.subsection?.length"
                      (click)="section.section_name !== 'Disabled Example' ? AcrossNameclick(item.snapshotType_name, section.section_name, '') : null">

                    <p class="subsection-parent"><span></span></p>
                    <p class="subsection-text"><span>{{ section.section_name }}</span></p>
                  </div>

                  <!-- Case: has subsections -->
                  <div class="tiles tile-normal"
                      [ngClass]="{'tile-disabled': subsection.subsection_name === 'Disabled Example'}"
                      *ngFor="let subsection of section.subsection"
                      (click)="subsection.subsection_name !== 'Disabled Example' ? AcrossNameclick(item.snapshotType_name, section.section_name, subsection.subsection_name) : null">

                    <!-- subsection-parent -->
                    <p class="subsection-parent">
                      <span>{{ subsection.subsection_name?.toLowerCase() === 'na' ? '' : section.section_name }}</span>
                    </p>

                    <!-- subsection-text -->
                    <p class="subsection-text">
                      <span
                        [title]="subsection.subsection_name?.toLowerCase() === 'na' ? section.section_name : subsection.subsection_name">
                        {{ subsection.subsection_name?.toLowerCase() === 'na' ? section.section_name : subsection.subsection_name }}
                      </span>
                    </p>
                  </div>
                </ng-container>                
              </div>        

            <!-- Line after each block -->
            <div class="line">
              <svg xmlns="http://www.w3.org/2000/svg" width="1068" height="3" viewBox="0 0 1068 3" fill="none">
                <path d="M0 1.69922H1068" stroke="#8029B6" stroke-opacity="0.1" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
          </div>
        </ng-container> 

        <!-- No Snapshot -->
        <ng-template #noSnapshot>
          <div class="no-snapshot-container">
            <h2 class="no-snapshot-title">
              {{ isSuperAdmin ? 'No Widget Configured for this Snapshot' : 'No Widgets Configured for Snapshots' }}
            </h2>
            <p class="no-snapshot-subtext">
              {{ isSuperAdmin
                ? 'Please configure a widget to explore data and insights.'
                : 'Please contact your administrator to configure widgets.' }}
            </p>
          </div>
      </ng-template>
      </div>
    </div>
    <div class="Buttons-container">
        <div class="Config-button" 
             [ngClass]="{'Config-button-snapshort': isSnapshot }" *ngIf="isSuperAdmin" (click)="configuration()">
            <div class="Config-button-txt" [ngClass]="{'Config-button-txt-snapshort': isSnapshot }">Add/Configure</div>
            <div class="Config-button-img-block">
                <div class="Config-button-img"></div>
            </div>
        </div>
        <div class="Output-button" *ngIf="!isSnapshot" (click)="navigateToModule()">
            <div class="Output-button-txt">{{ exploreBtn }}</div>
            <div class="Output-button-img-block">
                <div class="Output-button-img"></div>
            </div>
        </div>
    </div>
</div>